import gql from "graphql-tag"
import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"

const query = gql`
  query dealTagsForCurrentPackage {
    dealTagsForCurrentPackage {
      results {
        filterable
        name
        url
        uuid
        kind
        image
        locale
        childrenIds
      }
    }
  }
`

export const dealTagsForCurrentPackageKey = getQueryNames(query)[0]

export default query
